// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__YnSb6","header":"PatientQuestionnaire_header__1CWeR","info":"PatientQuestionnaire_info__1KGGB"};